export default __webpack_public_path__ + "static/media/cb_success.394d1863.png";